/**
 * Returns the article's commissioning edition (aka region) code from the <meta name="commissioning-region" /> tag.
 * If the tag doesn't exist, then an empty string is returned.
 *
 * @return string
 */
export function commissioningRegionFromMetaTag() {
  const metaTag = document.querySelector<HTMLMetaElement>("meta[name='commissioning-region']")
  return metaTag?.content || ""
}
